// Copyright (C) 2021 Bystronic Laser AG

export class RequestCanceledError extends Error {}
